<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iBoFdk/tc-custom/9781466884588.jpg?1730581564099" alt="This image is the cover for the book Design for Dying, Lillian Frost & Edith Head"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Design for Dying, Lillian Frost & Edith Head
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The first in a series of riveting behind-the-scenes mysteries, Renee Patrick's <i>Design for Dying </i>is a delightful romp through Hollywood's Golden Age.</b><br/><br/>Los Angeles, 1937. Lillian Frost has traded dreams of stardom for security as a department store salesgirl . . . until she discovers she's a suspect in the murder of her former roommate, Ruby Carroll. Party girl Ruby died wearing a gown she stole from the wardrobe department at Paramount Pictures, domain of Edith Head.<br/><br/>Edith has yet to win the first of her eight Academy Awards; right now she's barely hanging on to her job, and a scandal is the last thing she needs. To clear Lillian's name and save Edith's career, the two women join forces. <br/><br/>Unraveling the mystery pits them against a Hungarian princess on the lam, a hotshot director on the make, and a private investigator who's not on the level. All they have going for them are dogged determination, assists from the likes of Bob Hope and Barbara Stanwyck, and a killer sense of style. In show business, that just might be enough.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Renee Patrick
      </h2>
      
      <p class="authorDescription body article">RENEE PATRICK is the pseudonym for married authors Rosemarie and Vince Keenan. Rosemarie is a research administrator and a poet. Vince is a screenwriter and a journalist. Both native New Yorkers, they currently live in Seattle, Washington. <I>Design for Dying </I>is their first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58c609f0